<template>
    <div v-if="configModal.model">
        <div class="form-group row flex-nowrap">
            <label class="col-sm-3 text-nowrap" style="min-width: 280px"
                >{{ $t('managerForm.settingPage.titlePage') }} <span class="text-danger">*</span></label
            >
            <div class="col-sm-9" style="min-width: 815px">
                <InputText
                    :model.sync="configModal.title"
                    :config.sync="configEditFormPage.title"
                    @blur="validateFieldV2(configModal.title, configEditFormPage.title)"
                />
            </div>
        </div>
        <!-- block -->
        <div class="form-group row flex-nowrap" :index="indexLoading">
            <div class="col-sm-3" style="min-width: 380px">
                <template v-if="PAGE_TYPES._A.includes(propTypePage) || PAGE_TYPES._C.includes(propTypePage)">
                    <div v-if="isActivePageInput">
                        <template v-if="!isPageType(ID_PAGE_TYPE.C)">
                            <div class="mb-3">
                                <h5 class="border-top py-2">{{ $t('managerForm.settingPage.EditPage(homePage)') }}</h5>
                                <p class="block_property">必須ラベル・ページ遷移のボタン</p>
                                <p
                                    class="mb-4 p-0 pl-4 w-100 btn text--block"
                                    style="font-weight: 500"
                                    @click="handleEditButtonAndLabelPageInput('requiredLabel')"
                                >
                                    {{ $t('managerForm.settingPage.settingRequiredLabel') }}
                                </p>
                                <p
                                    class="mb-4 p-0 pl-4 w-100 btn text--block"
                                    style="font-weight: 500"
                                    @click="handleEditButtonAndLabelPageInput('confirmLabel')"
                                >
                                    {{ $t('managerForm.settingPage.settingConfirmLabel') }}
                                </p>
                                <p
                                    class="mb-0 p-0 pl-4 w-100 btn text--block"
                                    style="font-weight: 500"
                                    @click="handleEditButtonAndLabelPageInput('button')"
                                >
                                    {{ $t('managerForm.settingPage.settingButton') }}
                                </p>
                            </div>
                            <template>
                                <p class="block_property">{{ $t('managerForm.settingPage.addedDefaultItems') }}</p>
                                <div class="d-flex align-items-center p-3" style="gap: 12px">
                                    <Multiselect
                                        :id="`default_block_select`"
                                        :value.sync="default_block_select"
                                        :options="DEFAULT_BLOCK_COMMON"
                                        :config="configEditFormPage.configFieldSelectBlockDefault"
                                        @remove="handleRemoveBlock(configEditFormPage.configFieldSelectBlockDefault)"
                                    />
                                    <button class="btn btn-success btn-sm text-nowrap" type="button" @click="handleAddBlock('block_default')">
                                        {{ $t('btn.addTag') }}
                                    </button>
                                </div>
                            </template>
                        </template>
                        <template>
                            <p class="block_property">{{ $t('managerForm.settingPage.addedSettingItems') }}</p>
                            <div class="d-flex align-items-center p-3" style="gap: 12px">
                                <Multiselect
                                    :id="`select-block`"
                                    :value.sync="select_block"
                                    :options="listBlock"
                                    :config="configEditFormPage.configFieldSelectBlock"
                                    @remove="handleRemoveBlock(configEditFormPage.configFieldSelectBlock)"
                                />

                                <button class="btn btn-success btn-sm text-nowrap" type="button" @click="handleAddBlock('block_setting')">
                                    {{ $t('btn.addTag') }}
                                </button>
                            </div>
                        </template>
                        <div>
                            <div class="d-flex block_property">
                                <p class="mb-0">{{ $t('managerForm.settingPage.block') }}</p>
                                <p class="mb-0 ml-auto pr-1">{{ $t('managerForm.settingPage.choiceBlock') }}</p>
                            </div>
                            <div class="block_list">
                                <Draggable v-model="listBlockState" tag="div" ghost-class="ghost--option" @change="onDraggableChange">
                                    <div class="border-bottom px-3 py-4" v-for="(itemBlock, idx) in listBlockState" :key="`block-${idx}`">
                                        <div class="d-flex">
                                            <p
                                                class="mb-0 p-0 btn"
                                                @click="handleEditBlock(itemBlock)"
                                                :class="itemBlock.is_address_email_type_i ? '' : 'text--block'"
                                            >
                                                <span class="mr-2">
                                                    <i
                                                        :class="`${getIcon(itemBlock)} d-inline-flex align-items-center h-100`"
                                                        style="font-size: 1rem"
                                                        aria-hidden="true"
                                                    />
                                                </span>
                                                {{ itemBlock.block_name }}
                                            </p>
                                            <InputCheckBox
                                                v-if="!itemBlock.is_address_email_type_i"
                                                class="ml-auto"
                                                :model.sync="listChecked"
                                                :id="`check-itemBlock${idx}`"
                                                :value="idx"
                                                :label="``"
                                                @change="onHandleCheck(idx)"
                                            />
                                        </div>
                                    </div>
                                </Draggable>
                            </div>
                            <div class="d-flex justify-content-end mt-2">
                                <InputCheckBox
                                    v-if="listBlockState.length > 0"
                                    :model.sync="checkAll"
                                    :id="`checkAll`"
                                    :value="checkAll"
                                    :label="`全選択`"
                                    @change="onHandleCheckAll"
                                />
                            </div>
                            <div v-if="listBlockState.length > 0" class="d-flex justify-content-center mt-3" style="gap: 18px">
                                <button type="button" class="alldelete" @click="handleDeleteBlock">{{ $t('btn.delete') }}</button>
                                <button type="button" class="green02_copy" @click="handleCopyRight">{{ $t('btn.copy') }}</button>
                            </div>
                        </div>
                    </div>
                    <div v-if="isActivePageConfirm">
                        <div>
                            <h5 class="border-top py-2">{{ $t('managerForm.settingPage.EditPage(confirmationPage)') }}</h5>
                        </div>
                        <p class="block_property">{{ $t('managerForm.settingPage.properties') }}</p>
                        <p class="mb-0 p-0 pl-4 w-100 btn text--block" style="font-weight: 500" @click="handleEditButton">
                            {{ $t('managerForm.settingPage.settingButton') }}
                        </p>
                    </div>
                    <div v-if="isActivePageComplete">
                        <div>
                            <h5 class="border-top py-2">{{ $t('managerForm.settingPage.EditPage(completedPage)') }}</h5>
                        </div>
                        <p class="block_property">{{ $t('managerForm.settingPage.addedSettingItems') }}</p>
                        <div class="d-flex align-items-center p-3" style="gap: 12px">
                            <Multiselect
                                :id="`select-block`"
                                :value.sync="select_block"
                                :options="completeListBlock"
                                :config="configEditFormPage.configFieldSelectBlock"
                                @remove="handleRemoveBlock(configEditFormPage.configFieldSelectBlock)"
                            />

                            <button class="btn btn-success btn-sm text-nowrap" type="button" @click="handleAddBlock('block_setting')">
                                {{ $t('btn.addTag') }}
                            </button>
                        </div>
                        <div>
                            <div class="d-flex block_property">
                                <p class="mb-0">{{ $t('managerForm.settingPage.block') }}</p>
                                <p class="mb-0 ml-auto pr-1">{{ $t('managerForm.settingPage.choiceBlock') }}</p>
                            </div>
                            <div class="block_list">
                                <Draggable v-model="listBlockState" tag="div" ghost-class="ghost--option" @change="onDraggableChange">
                                    <div class="border-bottom px-3 py-4" v-for="(itemBlock, idx) in listBlockState" :key="`block-${idx}`">
                                        <div class="d-flex">
                                            <p class="mb-0 p-0 btn text--block" @click="handleEditBlock(itemBlock)">
                                                {{ itemBlock.block_name }}
                                            </p>
                                            <InputCheckBox
                                                class="ml-auto"
                                                :model.sync="listChecked"
                                                :id="`check-itemBlock${idx}`"
                                                :value="idx"
                                                :label="``"
                                                @change="onHandleCheck(idx)"
                                            />
                                        </div>
                                    </div>
                                </Draggable>
                            </div>
                            <div class="d-flex justify-content-end mt-2">
                                <InputCheckBox
                                    v-if="listBlockState.length > 0"
                                    :model.sync="checkAll"
                                    :id="`checkAll`"
                                    :value="checkAll"
                                    :label="`全選択`"
                                    @change="onHandleCheckAll"
                                />
                            </div>
                            <div v-if="listBlockState.length > 0" class="d-flex justify-content-center mt-3" style="gap: 18px">
                                <button type="button" class="alldelete" @click="handleDeleteBlock">{{ $t('btn.delete') }}</button>
                                <button type="button" class="green02_copy" @click="handleCopyRight">{{ $t('btn.copy') }}</button>
                            </div>
                        </div>
                    </div>
                </template>
                <template v-if="PAGE_TYPES._I.includes(propTypePage)">
                    <div class="mb-3">
                        <h5 v-if="[PAGE_TYPES._I[0]].includes(propTypePage)" class="border-top py-2">
                            {{ $t('managerForm.settingPage.EditPage(blankEmailRegistration)') }}
                        </h5>
                        <h5 v-if="[PAGE_TYPES._I[1]].includes(propTypePage)" class="border-top py-2">
                            {{ $t('managerForm.settingPage.EditPage(blankEmailConfirmation)') }}
                        </h5>
                        <h5 v-if="[PAGE_TYPES._I[2]].includes(propTypePage)" class="border-top py-2">
                            {{ $t('managerForm.settingPage.EditPage(blankEmailCompletion)') }}
                        </h5>
                        <p
                            v-if="[PAGE_TYPES._I[0], PAGE_TYPES._I[1], PAGE_TYPES._I[2]].includes(propTypePage)"
                            class="mb-4 p-0 pl-4 w-100 btn text--block"
                            style="font-weight: 500"
                            @click="handleEditTypeIScreen('text')"
                        >
                            {{ $t('managerForm.settingPage.pageTypeI.filedText') }}
                        </p>
                        <p
                            v-if="[PAGE_TYPES._I[0], PAGE_TYPES._I[1]].includes(propTypePage)"
                            class="mb-4 p-0 pl-4 w-100 btn text--block"
                            style="font-weight: 500"
                            @click="handleEditTypeIScreen('button')"
                        >
                            {{ $t('managerForm.settingPage.pageTypeI.fieldButton') }}
                        </p>
                        <!-- <p
                            v-if="[PAGE_TYPES._I[0]].includes(propTypePage)"
                            class="mb-4 p-0 pl-4 w-100 btn text--block"
                            style="font-weight: 500"
                            @click="handleEditTypeIScreen('requiredLabel')"
                        >
                            {{ $t('managerForm.settingPage.settingRequiredLabel') }}
                        </p>
                        <p
                            v-if="[PAGE_TYPES._I[0]].includes(propTypePage)"
                            class="mb-4 p-0 pl-4 w-100 btn text--block"
                            style="font-weight: 500"
                            @click="handleEditTypeIScreen('confirmLabel')"
                        >
                            {{ $t('managerForm.settingPage.settingConfirmLabel') }}
                        </p> -->
                    </div>
                </template>
                <template v-if="PAGE_TYPES._B.includes(propTypePage)">
                    <div class="mb-3">
                        <h5 v-if="[PAGE_TYPES._B[0]].includes(propTypePage)" class="border-top py-2">
                            {{ $t('managerForm.settingPage.pageTypeB.enterSericode') }}
                        </h5>
                        <h5 v-if="[PAGE_TYPES._B[1]].includes(propTypePage)" class="border-top py-2">
                            {{ $t('managerForm.settingPage.pageTypeB.lotterySericode') }}
                        </h5>
                        <h5 v-if="[PAGE_TYPES._B[2]].includes(propTypePage)" class="border-top py-2">
                            {{ $t('managerForm.settingPage.pageTypeB.winningSericode') }}
                        </h5>
                        <h5 v-if="[PAGE_TYPES._B[3]].includes(propTypePage)" class="border-top py-2">
                            {{ $t('managerForm.settingPage.pageTypeB.rejectionSericode') }}
                        </h5>

                        <!-- _B[2], _B[3]: existing text/button settings -->
                        <p
                            v-if="[PAGE_TYPES._B[1], PAGE_TYPES._B[2]].includes(propTypePage)"
                            class="mb-4 p-0 pl-4 w-100 btn text--block"
                            style="font-weight: 500"
                            @click="handleEditTypeBScreen('text')"
                        >
                            {{
                                propTypePage === PAGE_TYPES._B[1]
                                    ? $t('managerForm.settingPage.pageTypeI.fieldButton')
                                    : $t('managerForm.settingPage.pageTypeI.filedText')
                            }}
                        </p>
                        <template v-if="[PAGE_TYPES._B[0]].includes(propTypePage)">
                            <p
                                class="mb-4 p-0 pl-4 w-100 btn text--block"
                                style="font-weight: 500"
                                @click="handleEditButtonAndLabelPageInput('requiredLabel')"
                            >
                                {{ $t('managerForm.settingPage.settingRequiredLabel') }}
                            </p>
                            <p
                                class="mb-4 p-0 pl-4 w-100 btn text--block"
                                style="font-weight: 500"
                                @click="handleEditButtonAndLabelPageInput('confirmLabel')"
                            >
                                {{ $t('managerForm.settingPage.settingConfirmLabel') }}
                            </p>
                            <p
                                class="mb-4 p-0 pl-4 w-100 btn text--block"
                                style="font-weight: 500"
                                @click="handleEditButtonAndLabelPageInput('button')"
                            >
                                {{ $t('managerForm.settingPage.pageTypeI.fieldButton') }}
                            </p>
                            <p
                                v-if="dataFormEdit?.setting_lottery?.is_prize_before_the_draw"
                                class="mb-4 p-0 pl-4 w-100 btn text--block"
                                style="font-weight: 500"
                                @click="handleEditButtonAndLabelPageInput('prizeDesign')"
                            >
                                {{ $t('managerForm.settingPage.pageTypeB.prizePlacementSettings') }}
                            </p>
                        </template>

                        <!-- _B[0], _B[1], _B[3]: block management UI -->
                        <template v-if="[PAGE_TYPES._B[0], PAGE_TYPES._B[1], PAGE_TYPES._B[3]].includes(propTypePage)">
                            <template v-if="[PAGE_TYPES._B[0]].includes(propTypePage)">
                                <p class="block_property">{{ $t('managerForm.settingPage.addedDefaultItems') }}</p>
                                <div class="d-flex align-items-center p-3" style="gap: 12px">
                                    <Multiselect
                                        :id="`default_block_select`"
                                        :value.sync="default_block_select"
                                        :options="DEFAULT_BLOCK_COMMON"
                                        :config="configEditFormPage.configFieldSelectBlockDefault"
                                        @remove="handleRemoveBlock(configEditFormPage.configFieldSelectBlockDefault)"
                                    />
                                    <button class="btn btn-success btn-sm text-nowrap" type="button" @click="handleAddBlock('block_default')">
                                        {{ $t('btn.addTag') }}
                                    </button>
                                </div>
                            </template>
                            <p class="block_property">{{ $t('managerForm.settingPage.addedSettingItems') }}</p>
                            <div class="d-flex align-items-center p-3" style="gap: 12px">
                                <Multiselect
                                    :id="`select-block`"
                                    :value.sync="select_block"
                                    :options="[PAGE_TYPES._B[1], PAGE_TYPES._B[3]].includes(propTypePage) ? completeListBlock : listBlock"
                                    :config="configEditFormPage.configFieldSelectBlock"
                                    @remove="handleRemoveBlock(configEditFormPage.configFieldSelectBlock)"
                                />
                                <button class="btn btn-success btn-sm text-nowrap" type="button" @click="handleAddBlock('block_setting')">
                                    {{ $t('btn.addTag') }}
                                </button>
                            </div>
                            <div>
                                <div class="d-flex block_property">
                                    <p class="mb-0">{{ $t('managerForm.settingPage.block') }}</p>
                                    <p class="mb-0 ml-auto pr-1">{{ $t('managerForm.settingPage.choiceBlock') }}</p>
                                </div>
                                <div class="block_list">
                                    <Draggable v-model="listBlockState" tag="div" ghost-class="ghost--option" @change="onDraggableChange">
                                        <div class="border-bottom px-3 py-4" v-for="(itemBlock, idx) in listBlockState" :key="`block-${idx}`">
                                            <div class="d-flex">
                                                <p
                                                    class="mb-0 p-0 btn"
                                                    @click="handleEditBlock(itemBlock)"
                                                    :class="itemBlock.is_address_email_type_i ? '' : 'text--block'"
                                                >
                                                    <span class="mr-2">
                                                        <i
                                                            :class="`${getIcon(itemBlock)} d-inline-flex align-items-center h-100`"
                                                            style="font-size: 1rem"
                                                            aria-hidden="true"
                                                        />
                                                    </span>
                                                    {{ itemBlock.block_name }}
                                                </p>
                                                <InputCheckBox
                                                    v-if="
                                                        !itemBlock.is_address_email_type_i &&
                                                        !itemBlock.is_required_block &&
                                                        !itemBlock.is_serial_code_type_b
                                                    "
                                                    class="ml-auto"
                                                    :model.sync="listChecked"
                                                    :id="`check-itemBlock${idx}`"
                                                    :value="idx"
                                                    :label="``"
                                                    @change="onHandleCheck(idx)"
                                                />
                                            </div>
                                        </div>
                                    </Draggable>
                                </div>
                                <div class="d-flex justify-content-end mt-2">
                                    <InputCheckBox
                                        v-if="listBlockState.length > 0"
                                        :model.sync="checkAll"
                                        :id="`checkAll`"
                                        :value="checkAll"
                                        :label="`全選択`"
                                        @change="onHandleCheckAll"
                                    />
                                </div>
                                <div v-if="listBlockState.length > 0" class="d-flex justify-content-center mt-3" style="gap: 18px">
                                    <button type="button" class="alldelete" @click="handleDeleteBlock">{{ $t('btn.delete') }}</button>
                                    <button type="button" class="green02_copy" @click="handleCopyRight">{{ $t('btn.copy') }}</button>
                                </div>
                            </div>
                        </template>
                    </div>
                </template>
            </div>
            <div class="col-sm-9" style="min-width: 815px">
                <template v-if="PAGE_TYPES._A.includes(propTypePage)">
                    <SettingBlockForm
                        v-if="isSettingBlock"
                        ref="settingBlockForm"
                        :config="configSettingBlock"
                        :formBlock="initFormBlock"
                        :configFormInput="configFormInput"
                        :actionTimeAddBlock="actionTimeAddBlock"
                        :listTypeInput="listOptionText"
                        :bgrDefault="defaultBgr"
                        :inforSettingDesign="dataFormEdit.setting_designs"
                        @showSave="handleShowSaveBlock"
                        :listBlockCondition="listBlockCondition"
                        @cancel="handleCancelBlock"
                    />
                    <!-- ボタン -->
                    <div v-else-if="isSettingButton">
                        <div class="rightcontents">
                            <h3 class="mb-5" style="border-bottom: #333333 1px solid; font-size: 14px">
                                <span class="d-block" style="line-height: 31px; font-weight: bold">
                                    {{ $t('managerForm.settingPage.settingButton') }}
                                </span>
                            </h3>
                        </div>
                        <div class="settingout">
                            <h4>{{ $t('managerForm.settingPage.pageTransitionButtons') }}</h4>
                            <div class="col-12">
                                <div class="form-group row" style="border-bottom: #d8d8d8 1px solid">
                                    <label class="col-sm-2 text-nowrap" style="">{{ $t('managerForm.settingPage.buttonConfirm') }}</label>
                                    <div class="col-sm-10">
                                        <div class="form-group row" style="border-bottom: #d8d8d8 1px solid; padding-bottom: 20px">
                                            <label class="col-sm-1 text-nowrap" style="">{{ $t('managerForm.settingPage.labelButton') }}</label>
                                            <div class="col-sm-10">
                                                <InputText
                                                    :model.sync="settingButton.label_btn_confirm"
                                                    :config.sync="configEditButtonPage.configFieldButtonConfirm"
                                                    @blur="handleValidateField(configEditButtonPage.configFieldButtonConfirm)"
                                                />
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label class="col-sm-1 text-nowrap" style="">{{ $t('managerForm.settingPage.imageButton') }}</label>
                                            <div class="col-sm-10">
                                                <UploadImageCommon
                                                    :fileValues.sync="settingButton.img_btn_confirm"
                                                    :id="`ImageConfirm`"
                                                    :config="{
                                                        maxSize: 1024
                                                    }"
                                                >
                                                    <template #warning>
                                                        <div style="font-size: 13px">
                                                            {{ $t('managerForm.settingPage.noteImageButtonBeautiful') }}
                                                        </div>
                                                    </template>
                                                </UploadImageCommon>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-sm-2 text-nowrap" style="">{{ $t('managerForm.settingPage.buttonBack') }}</label>
                                    <div class="col-sm-10">
                                        <div class="form-group row" style="border-bottom: #d8d8d8 1px solid; padding-bottom: 20px">
                                            <label class="col-sm-1 text-nowrap" style="">{{ $t('managerForm.settingPage.labelButton') }}</label>
                                            <div class="col-sm-10">
                                                <InputText
                                                    :model.sync="settingButton.label_btn_back"
                                                    :config.sync="configEditButtonPage.configFieldButtonBack"
                                                    @blur="handleValidateField(configEditButtonPage.configFieldButtonBack)"
                                                />
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label class="col-sm-1 text-nowrap" style="">{{ $t('managerForm.settingPage.imageButton') }}</label>
                                            <div class="col-sm-10">
                                                <UploadImageCommon
                                                    :fileValues.sync="settingButton.img_btn_back"
                                                    :id="`ImageBack`"
                                                    :config="{
                                                        maxSize: 1024
                                                    }"
                                                >
                                                    <template #warning>
                                                        <div style="font-size: 13px">
                                                            {{ $t('managerForm.settingPage.noteImageButtonBeautiful') }}
                                                        </div>
                                                    </template>
                                                </UploadImageCommon>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="fbtnarea fbtnarea_block my-3">
                            <div class="fbtnarea text-center">
                                <button type="button" @click="handleCancelSettingBtn" class="btn btn-common-cancel mr-3">
                                    {{ $t('btn.cancel') }}
                                </button>
                                <button type="button " @click="handleSaveSettingBtn" class="text-nowrap save__button--setting">
                                    {{ $t('managerForm.settingPage.saveErrorMsg') }}
                                </button>
                            </div>
                        </div>
                    </div>
                    <div v-else-if="isSettingButtonPageInput">
                        <div class="rightcontents">
                            <h3 class="mb-5" style="border-bottom: #333333 1px solid; font-size: 14px">
                                <span
                                    v-if="currentSettingButtonOrLabel === 'requiredLabel'"
                                    class="d-block"
                                    style="line-height: 31px; font-weight: bold"
                                >
                                    必須ラベル・ページ遷移のボタン
                                </span>
                                <span
                                    v-if="currentSettingButtonOrLabel === 'confirmLabel'"
                                    class="d-block"
                                    style="line-height: 31px; font-weight: bold"
                                >
                                    確認ラベル・ページ遷移のボタン
                                </span>
                            </h3>
                        </div>
                        <template v-if="currentSettingButtonOrLabel === 'requiredLabel'">
                            <SettingLabel
                                typeLabel="required"
                                :settingLabel="settingRequiredLabel"
                                :configEditLabelPage="configEditLabelPage.configFieldLabelInputRequired"
                            ></SettingLabel>
                        </template>
                        <template v-else-if="currentSettingButtonOrLabel === 'confirmLabel'">
                            <SettingLabel
                                typeLabel="confirm"
                                :settingLabel="settingConfirmLabel"
                                :configEditLabelPage="configEditLabelPage.configFieldLabelInputConfirm"
                            ></SettingLabel>
                        </template>
                        <template v-else>
                            <div class="settingout">
                                <h4>{{ $t('managerForm.settingPage.pageTransitionButtons') }}</h4>
                                <div class="col-12">
                                    <div class="form-group row">
                                        <label class="col-sm-2 text-nowrap" style="">{{ $t('managerForm.settingPage.buttonRegister') }}</label>
                                        <div class="col-sm-10">
                                            <div class="form-group row" style="border-bottom: #d8d8d8 1px solid; padding-bottom: 20px">
                                                <label class="col-sm-1 text-nowrap" style="">{{ $t('managerForm.settingPage.labelButton') }}</label>
                                                <div class="col-sm-10">
                                                    <InputText
                                                        :model.sync="settingButtonPageInput.label_btn_register"
                                                        :config.sync="configEditButtonPage.configFieldButtonInput"
                                                        @blur="handleValidateField(configEditButtonPage.configFieldButtonInput)"
                                                    />
                                                </div>
                                            </div>
                                            <div class="form-group row">
                                                <label class="col-sm-1 text-nowrap" style="">{{ $t('managerForm.settingPage.imageButton') }}</label>
                                                <div class="col-sm-10">
                                                    <UploadImageCommon
                                                        :fileValues.sync="settingButtonPageInput.img_btn_register"
                                                        :id="`ImageConfirm`"
                                                        :config="{
                                                            maxSize: 1024
                                                        }"
                                                    >
                                                        <template #warning>
                                                            <div style="font-size: 13px">
                                                                {{ $t('managerForm.settingPage.noteImageButtonBeautiful') }}
                                                            </div>
                                                        </template>
                                                    </UploadImageCommon>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>

                        <div class="fbtnarea fbtnarea_block my-3">
                            <div class="fbtnarea text-center">
                                <button type="button" @click="handleCancelSettingBtn" class="btn btn-common-cancel mr-3">
                                    {{ $t('btn.cancel') }}
                                </button>
                                <button type="button " @click="handleSaveSettingBtn" class="text-nowrap save__button--setting">
                                    {{ $t('managerForm.settingPage.saveErrorMsg') }}
                                </button>
                            </div>
                        </div>
                    </div>
                </template>

                <template v-if="PAGE_TYPES._I.includes(propTypePage)">
                    <template v-if="[PAGE_TYPES._I[0]].includes(propTypePage) && isActiveEditTypeIScreen">
                        <template v-if="currentScreen_I === 'text'">
                            <div class="form-group row">
                                <label class="col-sm-2 text-nowrap">{{ $t('managerForm.settingPage.pageTypeI.emptyInputEmailText') }}</label>
                                <div class="col-sm-10">
                                    <Editor
                                        :id="`editor-registered_email_text`"
                                        :model.sync="initFormI.content"
                                        :configInit="{
                                            height: 300,
                                            error: false
                                        }"
                                    />
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-2 text-nowrap" style="min-width: 190px">{{
                                    $t('managerForm.settingPage.pageTypeI.useConfirmationBox')
                                }}</label>
                                <div class="col-sm-9">
                                    <InputCheckBox
                                        :model.sync="initFormI.confirm_input_twice"
                                        :id="`check-use_confirmation_box`"
                                        :value="initFormI.confirm_input_twice"
                                        :label="``"
                                    />
                                </div>
                            </div>
                        </template>
                        <template v-if="currentScreen_I === 'button'">
                            <div class="rightcontents">
                                <h3 class="mb-5" style="border-bottom: #333333 1px solid; font-size: 14px">
                                    <span class="d-block" style="line-height: 31px; font-weight: bold">
                                        {{ $t('managerForm.settingPage.settingButton') }}
                                    </span>
                                </h3>
                            </div>
                            <div class="settingout">
                                <h4>{{ $t('managerForm.settingPage.pageTransitionButtons') }}</h4>
                                <div class="col-12">
                                    <div class="form-group row">
                                        <label class="col-sm-2 text-nowrap" style="">{{ $t('managerForm.settingPage.buttonRegister') }}</label>
                                        <div class="col-sm-10">
                                            <div class="form-group row" style="border-bottom: #d8d8d8 1px solid; padding-bottom: 20px">
                                                <label class="col-sm-1 text-nowrap" style="">{{ $t('managerForm.settingPage.labelButton') }}</label>
                                                <div class="col-sm-10">
                                                    <InputText
                                                        :model.sync="initFormI.label_btn_register"
                                                        :config.sync="configEditButtonPage_I.configFieldButtonInput"
                                                        @blur="handleValidateField(configEditButtonPage_I.configFieldButtonInput)"
                                                    />
                                                </div>
                                            </div>
                                            <div class="form-group row">
                                                <label class="col-sm-1 text-nowrap" style="">{{ $t('managerForm.settingPage.imageButton') }}</label>
                                                <div class="col-sm-10">
                                                    <UploadImageCommon
                                                        :fileValues.sync="initFormI.img_btn_register"
                                                        :id="`ImageConfirm`"
                                                        :config="{
                                                            maxSize: 1024
                                                        }"
                                                    >
                                                        <template #warning>
                                                            <div style="font-size: 13px">
                                                                {{ $t('managerForm.settingPage.noteImageButtonBeautiful') }}
                                                            </div>
                                                        </template>
                                                    </UploadImageCommon>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <template v-if="currentScreen_I === 'requiredLabel'">
                            <SettingLabel
                                typeLabel="required"
                                :settingLabel="initFormI.settingRequiredLabel"
                                :configEditLabelPage="configEditLabelPage.configFieldLabelInputRequired"
                            ></SettingLabel>
                        </template>
                        <template v-else-if="currentScreen_I === 'confirmLabel'">
                            <SettingLabel
                                typeLabel="confirm"
                                :settingLabel="initFormI.settingConfirmLabel"
                                :configEditLabelPage="configEditLabelPage.configFieldLabelInputConfirm"
                            ></SettingLabel>
                        </template>
                        <div class="fbtnarea fbtnarea_block my-3">
                            <div class="fbtnarea text-center">
                                <button type="button" @click="handleCancelSettingBtn" class="btn btn-common-cancel mr-3">
                                    {{ $t('btn.cancel') }}
                                </button>
                                <button type="button " @click="handleSaveSettingBtn" class="text-nowrap save__button--setting">
                                    {{ $t('managerForm.settingPage.saveErrorMsg') }}
                                </button>
                            </div>
                        </div>
                    </template>
                    <template v-if="[PAGE_TYPES._I[1]].includes(propTypePage) && isActiveEditTypeIScreen">
                        <template v-if="currentScreen_I === 'text'">
                            <div class="form-group row">
                                <label class="col-sm-2 text-nowrap">{{ $t('managerForm.settingPage.pageTypeI.emptyConfirmEmailText') }}</label>
                                <div class="col-sm-10">
                                    <Editor
                                        :id="`editor-confirm_email_text`"
                                        :model.sync="initFormI.content"
                                        :configInit="{
                                            height: 300,
                                            error: false
                                        }"
                                    />
                                </div>
                            </div>
                        </template>
                        <template v-if="currentScreen_I === 'button'">
                            <div class="rightcontents">
                                <h3 class="mb-5" style="border-bottom: #333333 1px solid; font-size: 14px">
                                    <span class="d-block" style="line-height: 31px; font-weight: bold">
                                        {{ $t('managerForm.settingPage.settingButton') }}
                                    </span>
                                </h3>
                            </div>
                            <div class="settingout">
                                <h4>{{ $t('managerForm.settingPage.pageTransitionButtons') }}</h4>
                                <div class="col-12">
                                    <div class="form-group row" style="border-bottom: #d8d8d8 1px solid">
                                        <label class="col-sm-2 text-nowrap" style="">{{ $t('managerForm.settingPage.buttonConfirm') }}</label>
                                        <div class="col-sm-10">
                                            <div class="form-group row" style="border-bottom: #d8d8d8 1px solid; padding-bottom: 20px">
                                                <label class="col-sm-1 text-nowrap" style="">{{ $t('managerForm.settingPage.labelButton') }}</label>
                                                <div class="col-sm-10">
                                                    <InputText
                                                        :model.sync="initFormI.label_btn_confirm"
                                                        :config.sync="configEditButtonPage_I.configFieldButtonConfirm"
                                                        @blur="handleValidateField(configEditButtonPage_I.configFieldButtonConfirm)"
                                                    />
                                                </div>
                                            </div>
                                            <div class="form-group row">
                                                <label class="col-sm-1 text-nowrap" style="">{{ $t('managerForm.settingPage.imageButton') }}</label>
                                                <div class="col-sm-10">
                                                    <UploadImageCommon
                                                        :fileValues.sync="initFormI.img_btn_confirm"
                                                        :id="`ImageConfirm`"
                                                        :config="{
                                                            maxSize: 1024
                                                        }"
                                                    >
                                                        <template #warning>
                                                            <div style="font-size: 13px">
                                                                {{ $t('managerForm.settingPage.noteImageButtonBeautiful') }}
                                                            </div>
                                                        </template>
                                                    </UploadImageCommon>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <label class="col-sm-2 text-nowrap" style="">{{ $t('managerForm.settingPage.buttonBack') }}</label>
                                        <div class="col-sm-10">
                                            <div class="form-group row" style="border-bottom: #d8d8d8 1px solid; padding-bottom: 20px">
                                                <label class="col-sm-1 text-nowrap" style="">{{ $t('managerForm.settingPage.labelButton') }}</label>
                                                <div class="col-sm-10">
                                                    <InputText
                                                        :model.sync="initFormI.label_btn_back"
                                                        :config.sync="configEditButtonPage_I.configFieldButtonBack"
                                                        @blur="handleValidateField(configEditButtonPage_I.configFieldButtonBack)"
                                                    />
                                                </div>
                                            </div>
                                            <div class="form-group row">
                                                <label class="col-sm-1 text-nowrap" style="">{{ $t('managerForm.settingPage.imageButton') }}</label>
                                                <div class="col-sm-10">
                                                    <UploadImageCommon
                                                        :fileValues.sync="initFormI.img_btn_back"
                                                        :id="`ImageBack`"
                                                        :config="{
                                                            maxSize: 1024
                                                        }"
                                                    >
                                                        <template #warning>
                                                            <div style="font-size: 13px">
                                                                {{ $t('managerForm.settingPage.noteImageButtonBeautiful') }}
                                                            </div>
                                                        </template>
                                                    </UploadImageCommon>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <div class="fbtnarea fbtnarea_block my-3">
                            <div class="fbtnarea text-center">
                                <button type="button" @click="handleCancelSettingBtn" class="btn btn-common-cancel mr-3">
                                    {{ $t('btn.cancel') }}
                                </button>
                                <button type="button " @click="handleSaveSettingBtn" class="text-nowrap save__button--setting">
                                    {{ $t('managerForm.settingPage.saveErrorMsg') }}
                                </button>
                            </div>
                        </div>
                    </template>
                    <template v-if="[PAGE_TYPES._I[2]].includes(propTypePage) && isActiveEditTypeIScreen">
                        <template v-if="currentScreen_I === 'text'">
                            <div class="form-group row">
                                <label class="col-sm-2 text-nowrap">{{ $t('managerForm.settingPage.pageTypeI.completionPageBody') }}</label>
                                <div class="col-sm-10">
                                    <Editor
                                        :id="`editor-complete_email_text`"
                                        :model.sync="initFormI.content"
                                        :configInit="{
                                            height: 300,
                                            error: false
                                        }"
                                    />
                                </div>
                            </div>
                        </template>
                        <div class="fbtnarea fbtnarea_block my-3">
                            <div class="fbtnarea text-center">
                                <button type="button" @click="handleCancelSettingBtn" class="btn btn-common-cancel mr-3">
                                    {{ $t('btn.cancel') }}
                                </button>
                                <button type="button " @click="handleSaveSettingBtn" class="text-nowrap save__button--setting">
                                    {{ $t('managerForm.settingPage.saveErrorMsg') }}
                                </button>
                            </div>
                        </div>
                    </template>
                </template>
                <template v-if="PAGE_TYPES._B.includes(propTypePage)">
                    <template v-if="[PAGE_TYPES._B[0], PAGE_TYPES._B[1], PAGE_TYPES._B[3]].includes(propTypePage)">
                        <!-- Block editing panel for _B[0] (like page_input) -->
                        <SettingBlockForm
                            v-if="isSettingBlock"
                            ref="settingBlockForm"
                            :config="configSettingBlock"
                            :formBlock="initFormBlock"
                            :configFormInput="configFormInput"
                            :actionTimeAddBlock="actionTimeAddBlock"
                            :listTypeInput="listOptionText"
                            :bgrDefault="defaultBgr"
                            :inforSettingDesign="dataFormEdit.setting_designs"
                            @showSave="handleShowSaveBlock"
                            :listBlockCondition="listBlockCondition"
                            @cancel="handleCancelBlock"
                        />
                        <!-- Button setting for _B[0] -->
                        <div v-else-if="isSettingButtonPageInput">
                            <div class="rightcontents">
                                <h3 class="mb-5" style="border-bottom: #333333 1px solid; font-size: 14px">
                                    <span
                                        v-if="currentSettingButtonOrLabel === 'requiredLabel'"
                                        class="d-block"
                                        style="line-height: 31px; font-weight: bold"
                                    >
                                        必須ラベル・ページ遷移のボタン
                                    </span>
                                    <span
                                        v-else-if="currentSettingButtonOrLabel === 'confirmLabel'"
                                        class="d-block"
                                        style="line-height: 31px; font-weight: bold"
                                    >
                                        確認ラベル・ページ遷移のボタン
                                    </span>
                                    <span
                                        v-else-if="currentSettingButtonOrLabel === 'prizeDesign'"
                                        class="d-block"
                                        style="line-height: 31px; font-weight: bold"
                                    >
                                        賞品表示設定
                                    </span>
                                </h3>
                            </div>
                            <template v-if="currentSettingButtonOrLabel === 'requiredLabel'">
                                <SettingLabel
                                    typeLabel="required"
                                    :settingLabel="settingRequiredLabel"
                                    :configEditLabelPage="configEditLabelPage.configFieldLabelInputRequired"
                                ></SettingLabel>
                            </template>
                            <template v-else-if="currentSettingButtonOrLabel === 'confirmLabel'">
                                <SettingLabel
                                    typeLabel="confirm"
                                    :settingLabel="settingConfirmLabel"
                                    :configEditLabelPage="configEditLabelPage.configFieldLabelInputConfirm"
                                ></SettingLabel>
                            </template>
                            <template v-else-if="currentSettingButtonOrLabel === 'prizeDesign'">
                                <SettingDesignPrizeFormB
                                    ref="SettingDesignPrizeFormB"
                                    :dataForm="dataFormEdit"
                                    :formPrizeDesignInit="configModal.childPage.setting_layout_prize_serial"
                                ></SettingDesignPrizeFormB>
                            </template>
                            <template v-else>
                                <div class="settingout">
                                    <h4>{{ $t('managerForm.settingPage.pageTransitionButtons') }}</h4>
                                    <div class="col-12">
                                        <div class="form-group row">
                                            <label class="col-sm-2 text-nowrap" style="">{{ $t('managerForm.settingPage.buttonRegister') }}</label>
                                            <div class="col-sm-10">
                                                <div class="form-group row" style="border-bottom: #d8d8d8 1px solid; padding-bottom: 20px">
                                                    <label class="col-sm-1 text-nowrap" style="">{{
                                                        $t('managerForm.settingPage.labelButton')
                                                    }}</label>
                                                    <div class="col-sm-10">
                                                        <InputText
                                                            :model.sync="settingButtonPageInput.label_btn_register"
                                                            :config.sync="configEditButtonPage.configFieldButtonInput"
                                                            @blur="handleValidateField(configEditButtonPage.configFieldButtonInput)"
                                                        />
                                                    </div>
                                                </div>
                                                <div class="form-group row">
                                                    <label class="col-sm-1 text-nowrap" style="">{{
                                                        $t('managerForm.settingPage.imageButton')
                                                    }}</label>
                                                    <div class="col-sm-10">
                                                        <UploadImageCommon
                                                            :fileValues.sync="settingButtonPageInput.img_btn_register"
                                                            :id="`ImageConfirm`"
                                                            :config="{
                                                                maxSize: 1024
                                                            }"
                                                        >
                                                            <template #warning>
                                                                <div style="font-size: 13px">
                                                                    {{ $t('managerForm.settingPage.noteImageButtonBeautiful') }}
                                                                </div>
                                                            </template>
                                                        </UploadImageCommon>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <div class="fbtnarea fbtnarea_block my-3">
                                <div class="fbtnarea text-center">
                                    <button type="button" @click="handleCancelSettingBtn" class="btn btn-common-cancel mr-3">
                                        {{ $t('btn.cancel') }}
                                    </button>
                                    <button type="button " @click="handleSaveSettingBtn" class="text-nowrap save__button--setting">
                                        {{ $t('managerForm.settingPage.saveErrorMsg') }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </template>
                    <template v-if="[PAGE_TYPES._B[1]].includes(propTypePage) && isActiveEditTypeBScreen">
                        <SettingDrawFormB
                            ref="SettingDrawFormB"
                            :formDrawInit="configModal.childPage"
                            :configDrawFormB="formDrawConfig"
                            :typeSettingScreen="currentScreen_B"
                        />
                    </template>
                    <template v-if="[PAGE_TYPES._B[2]].includes(propTypePage) && isActiveEditTypeBScreen">
                        <SettingWinningFormB
                            ref="SettingWinningFormB"
                            :formWiningInit="configModal.childPage"
                            :configWinningFormB="formWinningConfig"
                            :typeSettingScreen="currentScreen_B"
                        />
                    </template>
                    <template v-if="[PAGE_TYPES._B[3]].includes(propTypePage) && isActiveEditTypeBScreen">
                        <SettingRejectionFormB
                            ref="SettingRejectionFormB"
                            :formRejectionInit="configModal.childPage"
                            :confiRejectionFormB="formRejectionConfig"
                            :typeSettingScreen="currentScreen_B"
                        />
                    </template>
                    <div
                        v-if="
                            [PAGE_TYPES._B[0], PAGE_TYPES._B[1], PAGE_TYPES._B[2], PAGE_TYPES._B[3]].includes(propTypePage) && isActiveEditTypeBScreen
                        "
                        class="fbtnarea fbtnarea_block my-3"
                    >
                        <div class="fbtnarea text-center">
                            <button type="button" @click="handleCancelSettingFormB" class="btn btn-common-cancel mr-3">
                                {{ $t('btn.cancel') }}
                            </button>
                            <button type="button " @click="handleSaveSettingBtn" class="text-nowrap save__button--setting">
                                {{ $t('managerForm.settingPage.saveErrorMsg') }}
                            </button>
                        </div>
                    </div>
                </template>

                <template v-if="isActiveIframe">
                    <div class="ifame_page overflow-auto">
                        <IframComponent class="mx-auto" :typeHandle="`edit`" :typePage="propTypePage" style="width: 100%" :dataForm="dataFormEdit" />
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import Draggable from 'vuedraggable';
import Swal from 'sweetalert2';
import Multiselect from '@/components/Multiselect/main.vue';
import SettingBlockForm from '../../setting-block-form/main.vue';
import IframComponent from '../../../iframe-page/main.vue';
import UploadImageCommon from '@/components/Uploads/Image/main.vue';
import Editor from '@/components/Editor/main.vue';
import SettingLabel from './setting-label.vue';
import SettingDrawFormB from './form-b/setting-draw.vue';
import SettingWinningFormB from './form-b/setting-winning.vue';
import SettingRejectionFormB from './form-b/setting-rejection.vue';
import SettingDesignPrizeFormB from './form-b/setting-layout-prize.vue';

import { mapState } from 'vuex';
import { cloneDeep } from 'lodash';
import { managerFormMethods } from '@/state/helpers';
import { InputText, InputCheckBox } from '@/components/Input';
import { validateField, validateAllField } from '@/utils/validate';
import { validateField as validateFieldV2, validateAllField as validateAllFieldV2 } from '@/utils/validate_v2';
import { BLOCK_COMMON, DEFAULT_BLOCK_COMMON } from '@/config/constants';
import { IMAGE_EXTENSIONS, tranferShortCode } from '@/utils/format';
import { initLayoutPrizeSerial } from '@/views/pages/phase2/manager-form/constants';

import {
    initFormBlock,
    initFormPostCodeBlock,
    initDepositBlock,
    initInfoFullNameBlock,
    initFormPhoneNumberBlock,
    initEmailAddressBlock,
    initEmailAddressConfirmBlock,
    initAgeAndGenderBlock,
    initGenderBlock,
    initXAccountBlock,
    initInstagramAccountBlock,
    configEditFormPage,
    configEditButtonPage,
    configEditLabelPage,
    configEditButtonPage_I,
    configFormDraw,
    configFormWinning,
    configFormRejection,
    initAddressEmailTypeIBlock
} from '../constants';
import { BGR_DEFAULT, configFormInput } from '../../setting-block-form/constants';
import { options as optionsDesign, configs as configsDesign } from '../../setting-design/constants';
import { OPTION_INPUT_FORMAT, OPTION_INPUT_FORMAT_FULL_NAME, LIST_PROVINCE_BLOCK, handleAddConfigOptions } from '../../setting-block-form/constants';
import { LABEL_TYPE_1, LABEL_TYPE_2 } from '../../setting-block-form/listTypeActiveField';
import { ALL_BLOCK_TYPE } from '@/config/constants';
import { onHandleInputFormat } from '../../../handlers';
import { PAGE_TYPES, ID_PAGE_TYPE } from '../../../constants';
import { onHandleShowConfirm } from '@/utils/handlers';
import { showMessage } from '@/utils/messages';

export default {
    name: 'ModalEditPage',
    components: {
        InputText,
        Multiselect,
        SettingBlockForm,
        Draggable,
        IframComponent,
        InputCheckBox,
        UploadImageCommon,
        Editor,
        SettingLabel,
        SettingDrawFormB,
        SettingWinningFormB,
        SettingRejectionFormB,
        SettingDesignPrizeFormB
    },
    props: {
        dataForm: {
            type: Object,
            required: true,
            default: () => null
        },
        configModal: {
            type: Object,
            required: true,
            default: () => null
        }
    },
    watch: {
        dataForm: {
            handler(val) {
                this.dataFormEdit = val;
                this.handleReceiveSettingBtnLabelPageInput();
                this.handleReceiveSettingBtnLabelFormI();
            },
            immediate: true,
            deep: true
        },

        'configModal.model': {
            handler(val) {
                if (val) {
                    this.indexLoading = this.indexLoading < 100 ? this.indexLoading++ : 0;
                    this.propTypePage = this.configModal?.childPage?.type_page_wl;
                    this.configEditFormPage = configEditFormPage();
                    this.conditionShowField();
                    this.cloneBlocks = cloneDeep(this.$store.state.managerForm.listBlockCreated);
                    this.isViewSetting = false;
                    this.select_block = null;
                    this.default_block_select = null;
                    if (PAGE_TYPES._I.includes(this.propTypePage)) {
                        this.initFormI = {
                            ...this.initFormI,
                            ...this.configModal.childPage.extension,
                            ...this.configModal.childPage.setting_buttons
                        };
                    }
                    if (this.dataForm.page_type.id === ID_PAGE_TYPE.I && this.propTypePage !== PAGE_TYPES._A[2] && this.cloneBlocks?.length === 0) {
                        initAddressEmailTypeIBlock().forEach((blockItem) => {
                            this.saveStateBlockForm(blockItem);
                        });
                    }
                    this.handleReceiveSettingBtnLabelPageInput();
                    this.handleReceiveSettingBtnLabelFormI();
                }
            },
            immediate: true
        },
        getBlockCreated: {
            handler(val) {
                this.listBlockState = val;
            },
            immediate: true
        }
    },
    data() {
        return {
            DEFAULT_BLOCK_COMMON,
            ID_PAGE_TYPE,
            optionsDesign,
            configsDesign,
            initFormBlock: initFormBlock(),
            initFormPostCodeBlock: initFormPostCodeBlock(),
            configFormInput: configFormInput(),
            configEditFormPage: configEditFormPage(),
            configEditButtonPage: configEditButtonPage(),
            configEditLabelPage: configEditLabelPage(),
            configEditButtonPage_I: configEditButtonPage_I(),
            arrExtension: IMAGE_EXTENSIONS,
            completeListBlock: BLOCK_COMMON.filter((blockCommonItem) => blockCommonItem.type == ALL_BLOCK_TYPE.BLOCK_DISPLAY_1),
            originPath: window.location.origin,
            dataFormEdit: this.dataForm,
            propTypePage: '',
            actionTimeAddBlock: 0,
            indexLoading: 0,
            isSettingBlock: false,
            isViewSetting: false,
            isSettingButton: false,
            isSettingButtonPageInput: false,
            currentSettingButtonOrLabel: 'button',
            isActivePageInput: false,
            isActivePageConfirm: false,
            isActivePageComplete: false,
            select_block: null,
            default_block_select: null,
            configSettingBlock: null,
            listChecked: [],
            listBlockState: [],
            cloneBlocks: [],
            listOptionText: [],
            settingButton: this.onInitButtonConfirm(),
            settingButtonPageInput: this.onInitButtonInput(),
            settingRequiredLabel: this.onInitRequiredLabel(),
            settingConfirmLabel: this.onInitConfirmLabel(),
            defaultBgr: null,
            checkAll: false,
            PAGE_TYPES,
            isActiveEditTypeIScreen: false,
            currentScreen_I: 'button',

            initFormI: {
                confirm_input_twice: true,
                settingRequiredLabel: this.onInitRequiredLabel(),
                settingConfirmLabel: this.onInitConfirmLabel(),
                ...this.onInitButtonInput(),
                ...this.onInitButtonConfirm()
            },
            isActiveEditTypeBScreen: false,
            currentScreen_B: 'text',
            formDrawConfig: configFormDraw(),
            formWinningConfig: configFormWinning(),
            formRejectionConfig: configFormRejection()
        };
    },
    computed: {
        isPageType() {
            return (pageType) => this.dataForm.page_type.id === pageType;
        },
        getBlockCreated() {
            return cloneDeep(this.$store.state.managerForm.listBlockCreated);
        },

        listBlockCondition() {
            return this.listBlockState.filter(
                (blockItem) =>
                    blockItem.block_type !== ALL_BLOCK_TYPE.BLOCK_DISPLAY_1 &&
                    blockItem.block_type !== ALL_BLOCK_TYPE.BLOCK_DISPLAY_2 &&
                    blockItem.status_record_block !== 'create'
            );
        },

        ...mapState({
            ...mapState('managerForm', ['buttonEvent'])
        }),

        isActiveIframe() {
            return (
                !this.isSettingBlock &&
                !this.isSettingButton &&
                !this.isSettingButtonPageInput &&
                !this.isActiveEditTypeIScreen &&
                !this.isActiveEditTypeBScreen &&
                ![PAGE_TYPES._I[3]].includes(this.propTypePage)
            );
        },
        listBlock() {
            if (this.isPageType(ID_PAGE_TYPE.C)) {
                return BLOCK_COMMON.filter((blockCommonItem) => [ALL_BLOCK_TYPE.BLOCK_DISPLAY_1].includes(blockCommonItem.type));
            }
            return BLOCK_COMMON;
        }
    },
    methods: {
        ...managerFormMethods,
        validateFieldV2,

        onInitButtonConfirm() {
            return {
                label_btn_confirm: '登録',
                label_btn_back: '戻る',
                img_btn_confirm: null,
                img_btn_back: null
            };
        },

        onInitButtonInput() {
            return {
                label_btn_register: this.$t('managerForm.settingPage.btnSaveForm'),
                img_btn_register: null
            };
        },
        onInitRequiredLabel() {
            return {
                display: 1,
                label_required: '※必須',
                position: 'after',
                font: {
                    id: 2,
                    label: "'NotoSansJP', sans-serif",
                    value: "'NotoSansJP', sans-serif",
                    url: 'https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@100..900&family=Yuji+Mai&display=swap'
                },
                font_size: 13,
                unit: { label: 'px(ピクセル)', value: 'px' },
                color: '#D10000'
            };
        },
        onInitConfirmLabel() {
            return {
                display: 1,
                label_required: '(確認)',
                font: {
                    id: 2,
                    label: "'NotoSansJP', sans-serif",
                    value: "'NotoSansJP', sans-serif",
                    url: 'https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@100..900&family=Yuji+Mai&display=swap'
                },
                font_size: 13,
                unit: { label: 'px(ピクセル)', value: 'px' },
                color: '#333333'
            };
        },

        conditionShowField() {
            this.isActivePageInput = [PAGE_TYPES._A[0], PAGE_TYPES._B[0], PAGE_TYPES._C[0]].includes(this.propTypePage);
            this.isActivePageConfirm = [PAGE_TYPES._A[1], PAGE_TYPES._I[1]].includes(this.propTypePage);
            this.isActivePageComplete = [PAGE_TYPES._I[2], PAGE_TYPES._A[2]].includes(this.propTypePage);
            this.updateButtonEvent({ visibilitySaveSettingPage: this.isActivePageConfirm });
        },
        onDraggableChange() {
            this.updateBlockList(this.listBlockState);
        },

        getBlockState() {
            return this.$store.state.managerForm.listBlockCreated;
        },

        handleSave() {
            let check = validateFieldV2(this.configModal.title, this.configEditFormPage.title);
            if (!check) return check;
            this.onHandleMapButtonPage();
            // Only update page_confirms when saving the confirm page (_A[1])
            if (this.propTypePage === PAGE_TYPES._A[1]) {
                this.onHandleSetValueButton();
                this.dataFormEdit.form_pages.page_confirms = {
                    ...this.dataFormEdit.form_pages.page_confirms,
                    setting_buttons: this.settingButton
                };
            }
            // Only update page_inputs when saving the input page (_A[0], _C[0])
            if ([PAGE_TYPES._A[0], PAGE_TYPES._C[0]].includes(this.propTypePage)) {
                this.handleReceiveSettingBtnLabelPageInput();
                this.dataFormEdit.form_pages.page_inputs = {
                    ...this.dataFormEdit.form_pages.page_inputs,
                    setting_buttons: this.settingButtonPageInput,
                    setting_requires: this.settingRequiredLabel,
                    setting_confirms: this.settingConfirmLabel
                };
            }
            // Only update page_input_serial_code when saving the input page (_B[0])
            if (this.propTypePage === PAGE_TYPES._B[0]) {
                this.handleReceiveSettingBtnLabelPageInput();
                this.dataFormEdit.form_pages.page_input_serial_code = {
                    ...this.dataFormEdit.form_pages.page_input_serial_code,
                    setting_buttons: this.settingButtonPageInput,
                    setting_requires: this.settingRequiredLabel,
                    setting_confirms: this.settingConfirmLabel
                };
            }

            this.configModal.model = false;
            this.isSettingBlock = false;
            this.select_block = null;
            this.$emit('updateConfig', this.configModal);
            return check;
        },

        onHandleMapButtonPage() {
            const foundPar = this.dataFormEdit.setting_page.pages.find((prItem) => prItem?.id == this.configModal?.parentPage?.id);
            const foudCh = foundPar?.page_child.find((chItem) => chItem?.id == this.configModal.childPage?.id);
            if (foudCh) {
                foudCh.name_page = this.configModal.title;
                foudCh.blocks = this.listBlockState;
            }
            // type I
            if (PAGE_TYPES._I.includes(this.propTypePage)) {
                foudCh.extension = {
                    content: this.initFormI.content ?? '',
                    confirm_input_twice: this.initFormI.confirm_input_twice ?? true
                };
                foudCh.setting_buttons = {
                    label_btn_register: this.initFormI.label_btn_register ?? this.$t('managerForm.settingPage.btnSaveForm'),
                    img_btn_register: this.initFormI.img_btn_register ?? null,
                    label_btn_confirm: this.initFormI.label_btn_confirm ?? '登録',
                    label_btn_back: this.initFormI.label_btn_back ?? '戻る',
                    img_btn_confirm: this.initFormI.img_btn_confirm ?? null,
                    img_btn_back: this.initFormI.img_btn_back ?? null
                };
                foudCh.setting_requires = this.initFormI.settingRequiredLabel;
                foudCh.setting_confirms = this.initFormI.settingConfirmLabel;
            }
            // type B
            if (PAGE_TYPES._B.includes(this.propTypePage)) {
                switch (this.propTypePage) {
                    case PAGE_TYPES._B[0]:
                        // _B[0] now supports blocks like page_input
                        // Do NOT mutate foudCh directly (it's inside Vuex state).
                        // Build the updated data and write to form_pages only.
                        this.dataFormEdit.form_pages[PAGE_TYPES._B[0]] = {
                            ...this.dataFormEdit.form_pages[PAGE_TYPES._B[0]],
                            ...foudCh,
                            name_page: this.configModal.title,
                            blocks: this.listBlockState,
                            setting_buttons: this.settingButtonPageInput,
                            setting_requires: this.settingRequiredLabel,
                            setting_confirms: this.settingConfirmLabel
                        };
                        break;
                    case PAGE_TYPES._B[1]:
                        foudCh.extension = {
                            display_btn_skip: this.configModal.childPage.extension?.display_btn_skip,
                            automatic_redirect_after: this.configModal.childPage.extension?.automatic_redirect_after,
                            btn_skip: this.configModal.childPage.extension?.btn_skip
                        };
                        this.dataFormEdit.form_pages[PAGE_TYPES._B[1]] = {
                            ...this.dataFormEdit.form_pages[PAGE_TYPES._B[1]],
                            ...foudCh,
                            name_page: this.configModal.title,
                            blocks: this.listBlockState
                        };
                        break;
                    case PAGE_TYPES._B[2]:
                        foudCh.extension = this.configModal.childPage.extension;
                        this.dataFormEdit.form_pages[PAGE_TYPES._B[2]] = {
                            ...this.dataFormEdit.form_pages[PAGE_TYPES._B[2]],
                            ...foudCh
                        };
                        break;
                    case PAGE_TYPES._B[3]:
                        foudCh.extension = this.configModal.childPage.extension;
                        this.dataFormEdit.form_pages[PAGE_TYPES._B[3]] = {
                            ...this.dataFormEdit.form_pages[PAGE_TYPES._B[3]],
                            ...foudCh,
                            name_page: this.configModal.title,
                            blocks: this.listBlockState
                        };
                        break;
                }
            }
        },

        handleClose() {
            const foundPar = this.dataFormEdit.setting_page.pages.find((prItem) => prItem.id == this.configModal.parentPage.id);
            const foudCh = foundPar.page_child.find((chItem) => chItem.id == this.configModal.childPage.id);
            foudCh.blocks = this.cloneBlocks;
            this.isSettingBlock = false;
            this.isSettingButton = false;
            this.select_block = null;
            this.configModal.model = false;
            this.configEditFormPage = configEditFormPage();
            this.configEditButtonPage = configEditButtonPage();
            this.updateButtonEvent({ eventEditPage: false });
        },

        handleRemoveBlock(configFieldSelectBlock) {
            this.isViewSetting = false;
            this.isSettingBlock = false;
            this.handleValidateField(configFieldSelectBlock);
            this.updateButtonEvent({ eventEditBlock: false, eventEditPage: true, eventEditBlockStep2: false, eventEditButton: false });
        },

        handleValidateField(configField) {
            validateField(configField);
        },

        async onHandleConfirm() {
            const confirmExitSettingForm = await onHandleShowConfirm({
                title: '',
                text: 'ページ設定内容がまだ保存されない可能性がありますが、移動してもよろしいですか。'
            });
            return confirmExitSettingForm;
        },

        onHandleScrollTop() {
            setTimeout(() => {
                const el = document.getElementById('scroll_edit');
                if (el) el.scrollIntoView({ block: 'start' });
            }, 250);
        },

        async handleAddBlock(typeBlock) {
            let isContinueAdd = true;
            let { eventEditBlock, eventEditBlockStep2 } = this.buttonEvent;
            if (eventEditBlock || eventEditBlockStep2) {
                isContinueAdd = await this.onHandleConfirm();
            }
            if (!isContinueAdd) return;
            this.actionTimeAddBlock = Math.random();
            this.isViewSetting = true;
            if (typeBlock === 'block_setting') {
                if (!this.select_block?.id) return;
                this.isSettingButton = false;
                this.isSettingButtonPageInput = false;
                this.updateButtonEvent({ eventEditBlock: true, eventEditPage: false, eventEditBlockStep2: false, eventEditButton: false });
                this.isSettingBlock = true;
                this.configSettingBlock = {
                    ...this.select_block,
                    block_name: this.select_block.name
                };
                this.configSettingBlock.typeScreen = this.propTypePage;
                this.initFormBlock = initFormBlock();
                if ([PAGE_TYPES._B[1], PAGE_TYPES._B[3]].includes(this.propTypePage)) {
                    this.initFormBlock.is_scroll_none = true;
                }
                if (
                    this.select_block.type == ALL_BLOCK_TYPE.BLOCK_FULL_NAME ||
                    this.select_block.type == ALL_BLOCK_TYPE.BLOCK_POSTAL_CODE ||
                    this.select_block.type == ALL_BLOCK_TYPE.BLOCK_SELECT_BOX_PROVINCE
                ) {
                    this.initFormBlock.personal_information_setting = true;
                }
                this.configFormInput = configFormInput();
                this.handleSetFollowTypeBlock(this.select_block);
                this.updateMessages();
            } else if (typeBlock === 'block_default') {
                if (!this.default_block_select?.id) return;
                this.onHandleBlockDefault();
                this.isSettingBlock = false;
                this.isSettingButton = false;
                this.isSettingButtonPageInput = false;
                this.updateButtonEvent({ eventEditBlock: false, eventEditPage: true, eventEditBlockStep2: false, eventEditButton: false });
            }
            this.onHandleScrollTop();
        },

        onHandleBlockDefault() {
            switch (this.default_block_select.type) {
                case ALL_BLOCK_TYPE.BLOCK_INFO_FULL_NAME:
                    initInfoFullNameBlock().forEach((blockItem) => {
                        this.saveStateBlockForm(blockItem);
                    });
                    break;
                case ALL_BLOCK_TYPE.BLOCK_PERSONAL_INFORMATION_BLOCK:
                    initInfoFullNameBlock().forEach((blockItem) => {
                        this.saveStateBlockForm(blockItem);
                    });
                    initFormPostCodeBlock().forEach((blockItem) => {
                        this.saveStateBlockForm(blockItem);
                    });
                    initFormPhoneNumberBlock().forEach((blockItem) => {
                        this.saveStateBlockForm(blockItem);
                    });
                    initEmailAddressConfirmBlock().forEach((blockItem) => {
                        this.saveStateBlockForm(blockItem);
                    });
                    break;
                case ALL_BLOCK_TYPE.BLOCK_EMAIL_ADDRESS_SINGLE:
                    initEmailAddressBlock().forEach((blockItem) => {
                        this.saveStateBlockForm(blockItem);
                    });
                    break;
                case ALL_BLOCK_TYPE.BLOCK_EMAIL_ADDRESS_CONFIRMATION:
                    initEmailAddressConfirmBlock().forEach((blockItem) => {
                        this.saveStateBlockForm(blockItem);
                    });
                    break;
                case ALL_BLOCK_TYPE.BLOCK_AGE_AND_GENDER:
                    initAgeAndGenderBlock().forEach((blockItem) => {
                        this.saveStateBlockForm(blockItem);
                    });
                    break;
                case ALL_BLOCK_TYPE.BLOCK_GENDER:
                    initGenderBlock().forEach((blockItem) => {
                        this.saveStateBlockForm(blockItem);
                    });
                    break;
                case ALL_BLOCK_TYPE.BLOCK_X_ACCOUNT:
                    initXAccountBlock().forEach((blockItem) => {
                        this.saveStateBlockForm(blockItem);
                    });
                    break;
                case ALL_BLOCK_TYPE.BLOCK_INSTAGRAM_ACCOUNT:
                    initInstagramAccountBlock().forEach((blockItem) => {
                        this.saveStateBlockForm(blockItem);
                    });
                    break;
                case ALL_BLOCK_TYPE.BLOCK_DEPOSIT:
                    initDepositBlock().forEach((blockItem) => {
                        this.saveStateBlockForm(blockItem);
                    });
                    break;
                case ALL_BLOCK_TYPE.BLOCK_POSTCODE_AND_PROVINCE:
                    initFormPostCodeBlock().forEach((blockItem) => {
                        this.saveStateBlockForm(blockItem);
                    });
                    break;
            }
        },

        async handleEditBlock(itemBlock) {
            if (itemBlock.is_address_email_type_i) return;
            itemBlock.type = itemBlock.block_type;
            let isContinueEdit = true;
            let { eventEditBlock, eventEditBlockStep2 } = this.buttonEvent;
            if (eventEditBlock || eventEditBlockStep2) {
                isContinueEdit = await this.onHandleConfirm();
            }
            if (!isContinueEdit) return;
            this.actionTimeAddBlock = Math.random();
            this.isViewSetting = true;
            this.updateButtonEvent({ eventEditBlock: true, eventEditPage: false, eventEditBlockStep2: false, eventEditButton: false });
            if (itemBlock.type == ALL_BLOCK_TYPE.BLOCK_POSTCODE_AND_PROVINCE) {
                this.isSettingBlock = false;
                return;
            }
            this.isSettingButtonPageInput = false;
            this.isActiveEditTypeBScreen = false;
            this.isSettingBlock = true;
            this.configSettingBlock = itemBlock;
            this.configSettingBlock.typeScreen = this.propTypePage;
            this.initFormBlock = initFormBlock(itemBlock);
            this.configFormInput = configFormInput(itemBlock);
            this.handleSetFollowTypeBlock(itemBlock);
            this.updateMessages(itemBlock.additional_setting.error_message_block);
            this.onHandleScrollTop();
        },

        handleSetFollowTypeBlock(itemBlock) {
            this.initFormBlock.block_type = itemBlock?.type;
            this.defaultBgr = BGR_DEFAULT(this.dataFormEdit.setting_designs.table_settings.cell_background_color);
            if (LABEL_TYPE_1.includes(this.initFormBlock?.block_type)) {
                this.configFormInput.configFieldMaxCharacters.errorField = this.$t('managerForm.settingPage.maxCharactersInput');
            }
            if (LABEL_TYPE_2.includes(this.initFormBlock?.block_type)) {
                this.configFormInput.configFieldMaxCharacters.errorField = `${this.$t('managerForm.settingPage.maxCharactersInput')}(入力欄毎)`;
            }

            if (this.initFormBlock.block_type == ALL_BLOCK_TYPE.BLOCK_TEXTAREA) {
                this.initFormBlock.max_characters = itemBlock?.max_characters ?? '30000';
                this.configFormInput.configFieldMaxCharacters.max = 30000;
            } else if (this.initFormBlock.block_type == ALL_BLOCK_TYPE.BLOCK_FULL_NAME) {
                this.initFormBlock.max_characters = itemBlock?.max_characters ?? '100';
            } else if (this.initFormBlock.block_type == ALL_BLOCK_TYPE.BLOCK_KEYWORD_BOX) {
                this.initFormBlock.max_characters = itemBlock?.max_characters ?? '32';
                this.configFormInput.configFieldKeywordUpload.length = Number(this.initFormBlock.max_characters);
            } else {
                this.initFormBlock.max_characters = itemBlock?.max_characters ?? '255';
            }

            if (this.initFormBlock.block_type == ALL_BLOCK_TYPE.BLOCK_SELECT_BOX_PROVINCE) {
                if (this.initFormBlock.option_value.some((item) => !item?.value) || this.initFormBlock.option_value.length <= 0) {
                    this.initFormBlock.option_value = LIST_PROVINCE_BLOCK();
                }
                this.configFormInput.validateArrayOption = handleAddConfigOptions(
                    this.configFormInput.validateArrayOption,
                    this.initFormBlock.option_value
                );
            }

            this.listOptionText =
                this.initFormBlock.block_type == ALL_BLOCK_TYPE.BLOCK_INPUT
                    ? OPTION_INPUT_FORMAT
                    : this.initFormBlock.block_type == ALL_BLOCK_TYPE.BLOCK_FULL_NAME
                      ? OPTION_INPUT_FORMAT_FULL_NAME
                      : [];

            if (this.initFormBlock.block_type == ALL_BLOCK_TYPE.BLOCK_CHECKBOX) {
                this.initFormBlock.setting_others.label_uncheck = '該当なし';
            }
            this.initFormBlock.input_format = onHandleInputFormat(this.initFormBlock);
        },

        handleShowSaveBlock(isShow) {
            this.updateButtonEvent({ eventEditBlock: false, eventEditPage: true, eventEditBlockStep2: false });
            this.isViewSetting = isShow;
            this.isSettingBlock = isShow;
            this.select_block = null;
            this.listBlockState = this.getBlockState();
        },

        handleCancelBlock(isCancel) {
            this.updateButtonEvent({ eventEditBlock: false, eventEditPage: true });
            this.isViewSetting = isCancel;
            this.isSettingBlock = isCancel;
        },

        handleDeleteBlock() {
            if (this.listChecked.length <= 0) return;
            Swal.fire({
                title: 'ブロックを削除します。一度削除すると元に戻すことはできません。',
                text: '',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#34c38f',
                cancelButtonColor: '#e8ecf4',
                confirmButtonText: 'OK',
                cancelButtonText: 'キャンセル'
            }).then((result) => {
                if (result.value) {
                    const listIdBlockPostCode = this.listBlockState
                        .filter((item) => item.block_type == ALL_BLOCK_TYPE.BLOCK_POSTAL_CODE)
                        .flatMap((item) => [
                            item.block_post_code.prefecture_insertion?.id,
                            item.block_post_code.city_insertion?.id,
                            item.block_post_code.town_area_name_insertion?.id
                        ]);

                    let isRelatedBlock = false;

                    for (let index = 0; index < this.listChecked.length; index++) {
                        const deleteBlock = this.listBlockState[this.listChecked[index]];

                        const relatedBlockPostCode = this.listBlockState
                            .filter((item) => item.block_type == ALL_BLOCK_TYPE.BLOCK_POSTAL_CODE)
                            .find(
                                (item) =>
                                    item.block_post_code?.prefecture_insertion?.id === deleteBlock.id ||
                                    item.block_post_code?.city_insertion?.id === deleteBlock.id ||
                                    item.block_post_code?.town_area_name_insertion?.id === deleteBlock.id
                            );

                        // ❗ Nếu không có block PostalCode liên quan thì bỏ qua
                        if (!relatedBlockPostCode) continue;

                        // ❗ Nếu feature_search_address === 2 → cho xoá luôn
                        if (relatedBlockPostCode.block_post_code?.feature_search_address === 2) {
                            continue;
                        }

                        // ❗ Nếu block nằm trong các ID đang được PostalCode sử dụng
                        if (listIdBlockPostCode.includes(deleteBlock.id)) {
                            const relatedIndex = this.listBlockState.indexOf(relatedBlockPostCode);

                            // Kiểm tra xem PostalCode block có nằm trong danh sách xoá không
                            const isPostalCodeAlsoDeleted = relatedIndex !== -1 && this.listChecked.includes(relatedIndex);

                            if (!isPostalCodeAlsoDeleted) {
                                showMessage(
                                    422,
                                    this.$bvToast,
                                    `${deleteBlock.block_name}は郵便番号${relatedBlockPostCode.block_name}の住所検索に使用されています。`
                                );
                                isRelatedBlock = true;
                                break;
                            }
                        }
                    }
                    if (
                        isRelatedBlock ||
                        this.onHandleCheckBlockMailUsedNotDelete(this.dataFormEdit.block_email_validates) ||
                        this.onHandleCheckBlockMailUsedNotDelete(this.dataFormEdit.block_email_condition_validates) ||
                        this.onHandleCheckBlockMailUsedNotDelete(this.dataFormEdit.setting_email_block_client_to_address_conditions) ||
                        this.onHandleCheckBlockMailUsedNotDelete(this.dataFormEdit.block_condition_validates, 'condition')
                    )
                        return;
                    this.listBlockState = this.listBlockState.filter((o, idx) => !this.listChecked.includes(idx));
                    this.updateBlockList(this.listBlockState);
                    this.listChecked = [];
                    this.isViewSetting = false;
                    this.isSettingBlock = false;
                    this.checkAll = false;
                    this.updateButtonEvent({ eventEditBlock: false, eventEditPage: true, eventEditBlockStep2: false });
                    this.$emit('updateBlockForm', {
                        idParentPage: this.configModal?.parentPage?.id,
                        idChildPage: this.configModal?.childPage?.id,
                        listBlockNotDelete: this.listBlockState
                    });
                }
            });
        },

        onHandleCheckBlockMailUsedNotDelete(blockEmailValidates, type) {
            for (let index = 0; index < this.listChecked.length; index++) {
                const currentIndex = this.listChecked[index];
                const currentBlock = this.listBlockState[currentIndex];

                // Tìm block điều kiện đang dùng block hiện tại
                const conditionBlock = this.listBlockState.find((item) =>
                    item.input_condition?.conditions.some((cond) => cond.block.id === currentBlock.id)
                );

                // ⭐ NEW: Nếu có conditionBlock và chính conditionBlock cũng nằm trong listChecked → CHO XOÁ
                if (conditionBlock) {
                    const conditionIndex = this.listBlockState.indexOf(conditionBlock);

                    if (this.listChecked.includes(conditionIndex)) {
                        // Xoá cả 2 ⇒ OK, tiếp tục kiểm tra block khác
                        continue;
                    }
                }

                // --- Kiểm tra email như cũ ---
                const deleteBlock = blockEmailValidates.find((item) => item.id === currentBlock.id);

                if (!deleteBlock && type !== 'condition') {
                    continue;
                }

                if (type === 'condition' && !conditionBlock) {
                    continue;
                }

                // --- Nếu tới đây tức là block bị dùng mà KHÔNG xoá conditionBlock → CHẶN XOÁ ---
                const msgType = deleteBlock?.type
                    ? deleteBlock.type === 'client'
                        ? '「《Email》」は自動返信メール(回答者向け)の配信先に使用されています。'
                        : deleteBlock.type === 'admin'
                          ? '「《Email》」は通知メールの返信先に使用されています。'
                          : ''
                    : '「《DeleteBlock》」は質問「《ConditionBlock》」の条件に使用されています。';

                showMessage(
                    422,
                    this.$bvToast,
                    tranferShortCode(msgType, {
                        Email: currentBlock.block_name,
                        DeleteBlock: currentBlock.block_name,
                        ConditionBlock: conditionBlock ? conditionBlock.block_name : ''
                    })
                );
                return true;
            }
            return false;
        },

        handleCopyRight() {
            if (this.listChecked.length <= 0) return;
            const listCopyed = cloneDeep(this.listBlockState).filter((o, idx) => this.listChecked.includes(idx));
            listCopyed.forEach((copyItem) => {
                delete copyItem.id;
                copyItem.status_record_block = 'create';
                copyItem.block_name = `${copyItem.block_name} Copy ${moment().format('YYYY-MM-DD')} ${moment().format('HH:mm')}`;
                if (copyItem.option_value?.length > 0) {
                    copyItem.option_value.forEach((option) => {
                        delete option.id;
                        delete option.form_block_id;
                    });
                }
                this.saveStateBlockForm(copyItem);
            });
            this.listChecked = [];
            this.checkAll = false;
        },
        onHandleCheck() {
            this.checkAll = this.listChecked.length == this.listBlockState.length;
        },
        onHandleCheckAll(val) {
            const indexAddressEmailTypeIBlock = this.listBlockState.findIndex((item) => item.is_address_email_type_i);
            const requiredBlockIndexes = this.listBlockState.map((item, idx) => (item.is_required_block ? idx : -1)).filter((idx) => idx !== -1);
            const serialCodeBlockIndexes = this.listBlockState
                .map((item, idx) => (item.is_serial_code_type_b ? idx : -1))
                .filter((idx) => idx !== -1);
            if (val) {
                this.listChecked = this.listBlockState.map((o, idx) => idx);
                if (indexAddressEmailTypeIBlock !== -1) this.listChecked = this.listChecked.filter((item) => item !== indexAddressEmailTypeIBlock);
                this.listChecked = this.listChecked.filter((idx) => !requiredBlockIndexes.includes(idx));
                this.listChecked = this.listChecked.filter((idx) => !serialCodeBlockIndexes.includes(idx));
            } else {
                this.listChecked = [];
            }
        },

        handleEditButton() {
            this.onHandleSetValueButton();
            this.isSettingButton = true;
            this.updateButtonEvent({ eventEditBlock: false, eventEditBlockStep2: false, eventEditPage: false, eventEditButton: true });
        },
        handleReceiveSettingBtnLabelPageInput() {
            const isSerialCodePage = this.propTypePage === PAGE_TYPES._B[0];
            const sourceFormPage = isSerialCodePage ? this.dataFormEdit.form_pages[PAGE_TYPES._B[0]] : this.dataFormEdit.form_pages.page_inputs;
            this.settingButtonPageInput = {
                ...this.onInitButtonInput(),
                ...sourceFormPage?.setting_buttons
            };
            this.settingRequiredLabel = {
                ...this.onInitRequiredLabel(),
                ...sourceFormPage?.setting_requires
            };
            this.settingConfirmLabel = {
                ...this.onInitConfirmLabel(),
                ...sourceFormPage?.setting_confirms
            };
        },
        handleReceiveSettingBtnLabelFormI() {
            this.initFormI = {
                ...this.onInitButtonInput(),
                ...this.configModal.childPage?.extension,
                ...this.configModal.childPage?.setting_buttons,
                settingRequiredLabel: {
                    ...this.onInitRequiredLabel(),
                    ...this.configModal.childPage?.setting_requires
                },
                settingConfirmLabel: {
                    ...this.onInitConfirmLabel(),
                    ...this.configModal.childPage?.setting_confirms
                }
            };
        },
        async handleEditButtonAndLabelPageInput(type) {
            let isContinueBtnInput = true;
            let { eventEditBlock, eventEditBlockStep2 } = this.buttonEvent;
            if (eventEditBlock || eventEditBlockStep2) {
                isContinueBtnInput = await this.onHandleConfirm();
            }
            if (!isContinueBtnInput) return;
            if (this.isActivePageInput) {
                this.handleReceiveSettingBtnLabelPageInput();
            }
            this.isSettingButtonPageInput = true;
            this.currentSettingButtonOrLabel = type;
            this.isSettingBlock = false;
            this.updateButtonEvent({ eventEditBlock: false, eventEditBlockStep2: false, eventEditPage: false, eventEditButton: true });
        },
        handleEditTypeIScreen(type) {
            this.configEditButtonPage_I = configEditButtonPage_I();
            this.currentScreen_I = type;
            this.isActiveEditTypeIScreen = true;
            this.handleReceiveSettingBtnLabelFormI();
            // if ([PAGE_TYPES._I[0]].includes(this.propTypePage)) {
            // }
            // if ([PAGE_TYPES._I[1]].includes(this.propTypePage)) {
            //     this.initFormI = {
            //         ...this.onInitButtonConfirm(),
            //         ...this.configModal.childPage.extension,
            //         ...this.configModal.childPage.setting_buttons
            //     };
            // }
            this.updateButtonEvent({ eventEditBlock: false, eventEditBlockStep2: false, eventEditPage: false, eventEditButton: true });
        },
        async handleEditTypeBScreen(type) {
            let isContinueBtnInput = true;
            let { eventEditBlock, eventEditBlockStep2 } = this.buttonEvent;
            if (eventEditBlock || eventEditBlockStep2) {
                isContinueBtnInput = await this.onHandleConfirm();
            }
            if (!isContinueBtnInput) return;
            this.currentScreen_B = type;
            this.isActiveEditTypeBScreen = true;
            this.isSettingBlock = false;
            if (!this.configModal.childPage.extension) {
                this.$set(this.configModal.childPage, 'extension', {});
            }
            if (this.propTypePage === PAGE_TYPES._B[1]) {
                if (this.configModal.childPage.extension.display_btn_skip === undefined) {
                    this.$set(this.configModal.childPage.extension, 'display_btn_skip', true);
                }
                if (this.configModal.childPage.extension.automatic_redirect_after === undefined) {
                    this.$set(this.configModal.childPage.extension, 'automatic_redirect_after', 3);
                }
                if (this.configModal.childPage.extension.btn_skip === undefined) {
                    this.$set(this.configModal.childPage.extension, 'btn_skip', '');
                }
            } else if ([PAGE_TYPES._B[2], PAGE_TYPES._B[3]].includes(this.propTypePage)) {
                if (this.configModal.childPage.extension.text_above === undefined) {
                    this.$set(this.configModal.childPage.extension, 'text_above', '');
                }
                if (this.configModal.childPage.extension.text_below === undefined) {
                    this.$set(this.configModal.childPage.extension, 'text_below', '');
                }
            }
            this.formDrawConfig = configFormDraw();
            this.formWinningConfig = configFormWinning();
            this.formRejectionConfig = configFormRejection();
            this.updateButtonEvent({ eventEditBlock: false, eventEditBlockStep2: false, eventEditPage: false, eventEditButton: true });
        },

        handleCancelSettingBtn() {
            this.configEditButtonPage = configEditButtonPage();
            this.isSettingButtonPageInput = false;
            this.isSettingButton = false;
            this.isActiveEditTypeIScreen = false;
            this.updateButtonEvent({ eventEditButton: false, eventEditPage: true });
        },

        handleSaveSettingBtn() {
            if (PAGE_TYPES._A.includes(this.propTypePage)) {
                let check = true;
                switch (this.currentSettingButtonOrLabel) {
                    case 'requiredLabel':
                        if (this.settingRequiredLabel.display === 1) {
                            check = validateField(this.configEditLabelPage.configFieldLabelInputRequired);
                        }
                        break;
                    case 'confirmLabel':
                        if (this.settingConfirmLabel.display === 1) {
                            check = validateField(this.configEditLabelPage.configFieldLabelInputConfirm);
                        }
                        break;
                    case 'text':
                        check = true;
                        break;
                    default:
                        check = this.isActivePageInput
                            ? validateField(this.configEditButtonPage.configFieldButtonInput)
                            : this.isActivePageConfirm
                              ? validateAllField({
                                    configFieldButtonBack: this.configEditButtonPage.configFieldButtonBack,
                                    configFieldButtonConfirm: this.configEditButtonPage.configFieldButtonConfirm
                                })
                              : true;
                        break;
                }
                if (!check) return;
                if (this.settingRequiredLabel.display === 0) {
                    this.settingRequiredLabel = {
                        ...this.onInitRequiredLabel(),
                        display: 0
                    };
                }
                if (this.settingConfirmLabel.display === 0) {
                    this.settingConfirmLabel = {
                        ...this.onInitConfirmLabel(),
                        display: 0
                    };
                }
                if (this.isActivePageConfirm) {
                    this.dataFormEdit.form_pages.page_confirms = {
                        ...this.dataFormEdit.form_pages.page_confirms,
                        setting_buttons: this.settingButton
                    };
                    this.isSettingButton = false;
                }
                if (this.isActivePageInput) {
                    if (!this.settingRequiredLabel.font_size) {
                        this.settingRequiredLabel.font_size = 13;
                    }
                    if (!this.settingConfirmLabel.font_size) {
                        this.settingConfirmLabel.font_size = 13;
                    }
                    this.dataFormEdit.form_pages.page_inputs = {
                        ...this.dataFormEdit.form_pages.page_inputs,
                        setting_buttons: this.settingButtonPageInput,
                        setting_requires: this.settingRequiredLabel,
                        setting_confirms: this.settingConfirmLabel
                    };
                    this.isSettingButtonPageInput = false;
                }
            } else if (PAGE_TYPES._I.includes(this.propTypePage)) {
                let check = true;
                if (this.currentScreen_I === 'requiredLabel') {
                    check = validateField(this.configEditLabelPage.configFieldLabelInputRequired);
                } else if (this.currentScreen_I === 'confirmLabel') {
                    check = validateField(this.configEditLabelPage.configFieldLabelInputConfirm);
                } else if (this.currentScreen_I === 'text') {
                    check = true;
                } else {
                    check = [PAGE_TYPES._I[0]].includes(this.propTypePage)
                        ? validateField(this.configEditButtonPage_I.configFieldButtonInput)
                        : [PAGE_TYPES._I[1]].includes(this.propTypePage)
                          ? validateAllField({
                                configFieldButtonBack: this.configEditButtonPage_I.configFieldButtonBack,
                                configFieldButtonConfirm: this.configEditButtonPage_I.configFieldButtonConfirm
                            })
                          : true;
                }
                if (!check) return;
                this.onHandleMapButtonPage();
                this.isActiveEditTypeIScreen = false;
            } else if (PAGE_TYPES._B.includes(this.propTypePage)) {
                let isValid = true;
                switch (this.propTypePage) {
                    case PAGE_TYPES._B[0]:
                        switch (this.currentSettingButtonOrLabel) {
                            case 'requiredLabel':
                                isValid =
                                    this.settingRequiredLabel.display === 1
                                        ? validateField(this.configEditLabelPage.configFieldLabelInputRequired)
                                        : true;
                                break;
                            case 'confirmLabel':
                                isValid =
                                    this.settingConfirmLabel.display === 1
                                        ? validateField(this.configEditLabelPage.configFieldLabelInputConfirm)
                                        : true;
                                break;
                            case 'prizeDesign':
                                isValid = this.$refs?.SettingDesignPrizeFormB?.onHandleValidateAll() ?? true;
                                break;
                            default:
                                isValid = validateField(this.configEditButtonPage.configFieldButtonInput);
                                break;
                        }

                        if (isValid) {
                            if (this.settingRequiredLabel.display === 0) {
                                this.settingRequiredLabel = { ...this.onInitRequiredLabel(), display: 0 };
                            }
                            if (this.settingConfirmLabel.display === 0) {
                                this.settingConfirmLabel = { ...this.onInitConfirmLabel(), display: 0 };
                            }
                            if (!this.settingRequiredLabel.font_size) {
                                this.settingRequiredLabel.font_size = 13;
                            }
                            if (!this.settingConfirmLabel.font_size) {
                                this.settingConfirmLabel.font_size = 13;
                            }

                            const foundPar = this.dataFormEdit.setting_page.pages.find((prItem) => prItem?.id == this.configModal?.parentPage?.id);
                            const foudCh = foundPar?.page_child.find((chItem) => chItem?.id == this.configModal.childPage?.id);
                            if (foudCh) {
                                foudCh.setting_buttons = this.settingButtonPageInput;
                                foudCh.setting_requires = this.settingRequiredLabel;
                                foudCh.setting_confirms = this.settingConfirmLabel;
                                foudCh.setting_layout_prize_serial =
                                    this.$refs?.SettingDesignPrizeFormB?.getDataFormPrizeDesign() ?? initLayoutPrizeSerial();
                            }
                            this.dataFormEdit.form_pages[PAGE_TYPES._B[0]] = {
                                ...this.dataFormEdit.form_pages[PAGE_TYPES._B[0]],
                                setting_buttons: this.settingButtonPageInput,
                                setting_requires: this.settingRequiredLabel,
                                setting_confirms: this.settingConfirmLabel,
                                setting_layout_prize_serial: this.$refs?.SettingDesignPrizeFormB?.getDataFormPrizeDesign() ?? initLayoutPrizeSerial()
                            };
                            this.isSettingButtonPageInput = false;
                        }
                        break;
                    case PAGE_TYPES._B[1]:
                        this.configModal.childPage = this.$refs.SettingDrawFormB.getDataFormDraw();
                        isValid = validateAllFieldV2(this.configModal.childPage, this.formDrawConfig);
                        break;
                    case PAGE_TYPES._B[2]:
                        this.configModal.childPage = this.$refs.SettingWinningFormB.getDataFormWining();
                        isValid = validateAllFieldV2(this.configModal.childPage, this.formWinningConfig);
                        break;
                    case PAGE_TYPES._B[3]:
                        this.configModal.childPage = this.$refs.SettingRejectionFormB.getDataFormRejection();
                        isValid = validateAllFieldV2(this.configModal.childPage, this.formRejectionConfig);
                        break;
                }
                if (!isValid) return;
                this.onHandleMapButtonPage();
                this.isActiveEditTypeBScreen = false;
            }
            this.updateButtonEvent({ eventEditButton: false, eventEditPage: true });
        },
        handleCancelSettingFormB() {
            this.$refs?.SettingDrawFormB?.resetDataFormDraw();
            this.$refs?.SettingWinningFormB?.resetDataFormWining();
            this.$refs?.SettingRejectionFormB?.resetDataFormRejection();
            this.$refs?.SettingDesignPrizeFormB?.resetDataFormPrizeDesign();
            this.isActiveEditTypeBScreen = false;
            this.updateButtonEvent({ eventEditButton: false, eventEditPage: true });
        },

        onRestWork() {
            this.settingButton = this.onInitButtonConfirm();
            this.settingButtonPageInput = this.onInitButtonInput();
            this.configModal.model = false;
            this.isSettingButton = false;
            this.isSettingButtonPageInput = false;
            this.isActiveEditTypeIScreen = false;
            this.isActiveEditTypeBScreen = false;
        },

        onHandleSetValueButton() {
            this.settingButton = {
                ...this.onInitButtonConfirm(),
                ...this.dataFormEdit?.form_pages.page_confirms?.setting_buttons
            };
        },

        onHiddenBtnWork() {
            this.isSettingButtonPageInput = false;
        },

        getIcon(item) {
            const iconFound = this.listBlock.find((itemBlock) => itemBlock.type == item.block_type);
            return iconFound ? iconFound.icon : '';
        }
    }
};
</script>

<style lang="scss" scoped>
.btn-outline-success:hover {
    color: #1cbb8c;
    border-color: #1cbb8c;
    background-color: #fff;
}
.text--block {
    text-align: left;
    color: #339162;
    &:hover {
        color: #70be97;
    }
}

.ghost--option {
    opacity: 0.5;
    background-color: #f8f9fa;
    border: dashed 1px #ccc;
}
.alldelete {
    border-radius: 4px;
    padding: 5px 15px;
    background-color: #fff;
    border: 1px solid #707070;
    &:hover {
        background-color: #ededed;
    }
}

.green02_copy {
    border-radius: 4px;
    padding: 5px 15px;
    color: #339162;
    border: solid 1px #339162;
    background-color: #fff;
    &:hover {
        opacity: 0.7;
    }
}

.block_property {
    background: #808080;
    font-size: 12px;
    background: #e5e5e5;
    font-weight: normal;
    padding: 8px 15px 8px 20px;
}

.save__button--setting {
    background: #339162;
    border: solid 1px #339162;
    color: #ffffff;
    font-size: 13px;
    padding: 9px;
    border-radius: 4px;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    font-weight: bold;
    width: 160px;

    &:hover {
        opacity: 0.8;
    }
}
</style>
